import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#nav-menu" }),
    /*#__PURE__*/_createTextVNode(" NavMenu ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Menu that provides navigation for your website. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUITopBar = _resolveComponent("EUITopBar")
  const _component_EUISideBar = _resolveComponent("EUISideBar")
  const _component_EUICollapse = _resolveComponent("EUICollapse")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUITopBar),
    _createVNode(_component_EUISideBar),
    _createVNode(_component_EUICollapse)
  ], 64))
}